import { render } from "./CreateTransactionType.vue?vue&type=template&id=85785650"
import script from "./CreateTransactionType.vue?vue&type=script&lang=js"
export * from "./CreateTransactionType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__